import { useState, useEffect } from 'react';
import { useSchoolLogo } from '../../hooks/useSchoolLogo';

/**
 * Component to display school logo or fallback emoji
 * @param {string} size - 'small', 'medium', or 'large' (default: 'medium')
 * @param {string} className - Additional CSS classes
 * @param {boolean} showEmoji - Whether to show emoji as fallback (default: true)
 */
export default function SchoolLogo({ 
  size = 'medium', 
  className = '',
  showEmoji = true 
}) {
  const schoolLogo = useSchoolLogo();
  const [imageError, setImageError] = useState(false);
  
  const sizeClasses = {
    small: 'w-4 h-4 md:w-6 md:h-6',
    medium: 'w-6 h-6 md:w-8 md:h-8',
    large: 'w-8 h-8 md:w-12 md:h-12'
  };

  const emojiSizeClasses = {
    small: 'text-lg md:text-xl',
    medium: 'text-xl md:text-2xl',
    large: 'text-2xl md:text-3xl'
  };

  // Reset error state when logo changes
  useEffect(() => {
    if (schoolLogo) {
      setImageError(false);
    }
  }, [schoolLogo]);

  if (schoolLogo && !imageError) {
    return (
      <img 
        src={schoolLogo} 
        alt="School logo" 
        className={`${sizeClasses[size]} object-contain ${className}`}
        onError={() => {
          setImageError(true);
        }}
      />
    );
  }

  if (showEmoji) {
    return <span className={`${emojiSizeClasses[size]} ${className}`}>🥋</span>;
  }

  return null;
}

